// Atlas ephemeral-build routing header.
//
// When a Vercel PP/canary build should hit a specific atlas PR's ephemeral
// backend build, the deploy pipeline injects `NEXT_PUBLIC_ATLAS_PR_NUMBER`
// via --build-env. Requests to the AlleyPin backend then carry
// `x-atlas-pr-number`, which the atlas gateway uses to route to the PR's
// pod instead of the default one. Empty/unset = normal behaviour.
const ATLAS_PR_NUMBER = process.env.NEXT_PUBLIC_ATLAS_PR_NUMBER

export const atlasPrHeader = () =>
  ATLAS_PR_NUMBER ? { "x-atlas-pr-number": ATLAS_PR_NUMBER } : {}
